export const DRAG_DRAWER_CONTENT_CLASS_NAME = 'drag-drawer-content';
